import { get } from 'lodash';
import { getTextWidth } from '../../utils/textWidth';

// eslint-disable-next-line import/no-anonymous-default-export
export default (props) => {
  const routes = get(props, 'result.raw.data.routes');
  const isTollsActive = get(props, 'result.state.isTollsActive');
  const showTollbooth = get(props, 'result.state.showTollbooth', true);
  const showTollboothName = get(props, 'result.state.showTollboothName', true);
  
  if (!routes || !isTollsActive || !showTollbooth) {
    return [];
  }
  const currentRouteIndex = get(props, 'result.state.currentRoute', 0);
  const sections = get(routes[currentRouteIndex], 'sections', []);
  const tollCollectionLocations = [];
  sections.forEach(section => {
    const { tolls = [] } = section;
    tolls.forEach(toll => {
      const locations = toll.tollCollectionLocations || [];
      tollCollectionLocations.push(...locations);
    })
  });

  const currentRouteMarkers = tollCollectionLocations.map(({location, name="N/A"}) => {
      const { lat, lng } = location;
      const text = showTollboothName ? name : 'TOLL';
      // const icon = postActions[0].duration >= 6 * 60 * 60 ? 
      //   '&#x1F6CF;' : 
      //   '&#x2615;';      // coffee
        // '&#x1F375;';     // tea
        // '&#x1F17F;';     // parking 
        // '&#x1F964;';     // cup with straw
        // '&#x1F6CF;';   // knife and fork

      return {
        value: `${lat},${lng}`,
        text: text,
        textWidth: Math.round(getTextWidth(text)/1.65 + 35),
        dsIcon: `toll`,
        draggable: false,
        isCurrentRoute: true,
        iconHeight: 24,
        iconWidth: Math.round(getTextWidth(text)/1.65 + 35),
        iconX:11.5,
        iconY:26,
        rectIcon: true,
      };
    });

  return [...currentRouteMarkers];
};
